import React from 'react';
import DangerIcon from '@assets/icons/danger-icon.svg';
import WaningToast from '@assets/icons/waning-toast-icon.svg';
import { useLanguage } from 'Context/LanguageContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './SmartTable.css';
import { Box } from '@mui/material';

const ICON_WARNING_MESSAGES = {
  301: 'EXIST_ASSOCIATE_BY_TASK',
  302: 'EXIST_ASSOCIATE_BY_TEAM',
  303: 'EXIST_ASSOCIATE_BY_SYSTEM',
  304: 'UNKNOWN_ERROR_DELETE_USER',
  334: 'CONFLICT_EMERGENCIES',
  335: 'CONFLICT_ROUTE',
  336: 'CONFLICT_SERVICE_ON_ROUTE',
  351: 'EXIST_CLIENT_ASSOCIATE',
  400: 'EXIST_BRANCHES_BY_COMPANY',
  401: 'EXIST_SUBCOMPANIES_BY_COMPANY',
  450: 'EXIST_ASSOCIATE_BY_TASK_AGENT',
  451: 'EXIST_ASSOCIATE_BY_SYSTEM_AGENT',
  452: 'UNKNOWN_ERROR_DELETE_AGENT',
  500: 'EXIST_ASSOCIATE_BY_AGENT',
  501: 'EXIST_ASSOCIATE_BY_MANAGER',
  502: 'UNKNOWN_ERROR_DELETE_TEAM',
  810: 'FAIL_UPDATE_GROUP_TASKS',
  811: 'FAIL_DELETE_TASKS',
  812: 'WRONG_DELETE_STATUS',
  813: 'GROUP_NOT_FOUND',
};

const getErrorElements = (row, lan) => {
  if (row.idBranch) return { name: lan.branch, id: row.idBranch };
  if (row.idCompany) return { name: lan.nameCompany, id: row.idCompany };
  if (row.idUser) return { name: lan.element, id: row.idUser };
  if (row.id) return { name: lan.route, id: row.id };
  if (row.idAgent) return { name: lan.agent, id: row.idAgent };
  if (row.idGroupTask) return { name: lan.groupTask, id: row.idGroupTask };
  if (row.idTeam) return { name: lan.team, id: row.idTeam };
  return { name: '', id: 0 };
};

const IconFormatterWarning =  React.memo( ({ row, iconWarning }) => {
  	const lan = useLanguage();
  	const { name, id } = getErrorElements(row, lan);
  	const notify = (code) => {
   		const messageKey = ICON_WARNING_MESSAGES[code];
    	const message = lan[messageKey] || lan.UNKNOWN_ERROR;
		toast(
			<div className='row'>
				<div className='col-auto'>
          <Box component="img" width={38} src={WaningToast} alt="" />
				</div>
				<div className='col-auto d-flex justify-content-center align-self-center'>
				<span className='boldText'>{name} {id}</span>: {message}
				</div>
			</div>,
			{
				position: toast.POSITION.BOTTOM_CENTER,
				hideProgressBar: true,
				bodyClassName: 'toast-font-style',
				autoClose: 4500,
			}
		);
	};
	return (
		<div className='row no-padding'>
			{iconWarning !== 0 && (
        <Box
          component="img"
          src={DangerIcon}
          onMouseOver={() => notify(iconWarning)}
          alt=""
          className="SmartTable-icon-image"
          sx={{ display: 'block' }}
        />
			)}
		</div>
	);
});
export default IconFormatterWarning;
